import { getInstance } from "@eppo/js-client-sdk";
import { useQuery } from "@faire/web-api--source/endpoints/www/api/user/session/get-hooks";
import React from "react";

import EppoRandomizationProvider from "./EppoRandomizationProvider";

const EppoAATestContent: React.FC = () => {
  const { data: sessionData, isLoading, error } = useQuery();
  if (isLoading || error || !sessionData?.session_token) {
    return null;
  }
  const eppoClient = getInstance();

  const sessionToken = sessionData?.session_token;

  const testVariant = eppoClient.getBooleanAssignment(
    "AA-Test-On-LOHP",
    sessionToken,
    {},
    false
  );
  return <div data-test-id={`eppo-aa-test-${testVariant}`} />;
};

export const EppoAATest: React.FC = () => {
  return (
    <EppoRandomizationProvider>
      <EppoAATestContent />
    </EppoRandomizationProvider>
  );
};
